// Generated by `npm run supportedBrowsers`
// Do not edit manually
export const supportedBrowsers =
  /Edge?\/(12\d|1[3-9]\d|[2-9]\d\d|\d{4,})\.\d+(\.\d+|)|Chrom(ium|e)\/(12\d|1[3-9]\d|[2-9]\d\d|\d{4,})\.\d+(\.\d+|)/;
